window.VegasCart = {
	add: function (lparams, callback) {
		let params = {
			id: lparams.id,
			cnt: lparams.cnt,
			_token: App.csrf
		};

		this.addRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data);
				VegasCart.popup(data.product.title, true);

				if (typeof callback == 'function')
					callback(data);
			}
		});
	},

	remove: function (lparams, callback) {
		let params = {
			id: lparams.id,
			pivot_id: lparams.pivot_id,
			_token: App.csrf
		};

		this.removeRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data);

				if (typeof callback == 'function')
					callback(data);
			}
		});
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},
	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},
	changeProductDataRequest: function(params, callback) {
		$.post('/cart/change_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);

			if (!data.error) {
				VegasCart.total(data);
			}
		});
	},

	changeCnt: function (params, callback) {
		this.changeProductDataRequest({
			_token: App.csrf,
			id: params.id,
			pivot_id: params.pivot_id,
			cnt: params.cnt
		}, callback);
	},


	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter="products-count"]').attr('data-cnt', data.products_count).fadeIn();
		}

		if (typeof data.cart_sum !== 'undefined') {
			$('[data-cart][data-counter=cart-total]').text(output_money_decimal(data.cart_sum));
		}
	},

	popup: function (title, status = false) {
		let $modal = $('#modalCartProduct');

		$modal.find('.title').text(title);
		$modal.modal('show');
		$modal.closest('body').find('.modal-backdrop.in').hide();

		/*setTimeout(() => {
			$modal.modal('hide')
		}, 2000);*/
	}
};

$(document).ready(function () {
	let $window = $(window),
		$body = $('body'),
		$document = $(document),
		$modalOrder = $("#modal-order")
	;

	// добавление прайса в корзину из таблицы
	$document.on('click', '.table-price-products [data-cart][data-action=add]', function () {
		let $row = $(this).closest('.row');

		$(this).attr('data-action', 'remove').text('Убрать');

		VegasCart.add(
			{
				id: $(this).data('id'),
				cnt: $row.find('[name=cnt]').val()
			},
			function (data) {
				$row.addClass('in-cart').attr('data-pivot_id', data.product.pivot_id);
			}
		);

		return false;
	});
	// удаление прайса из таблицы
	$document.on('click', '.table-price-products [data-cart][data-action=remove]', function () {
		let $row = $(this).closest('.row');

		$(this).attr('data-action', 'add').text('В корзину');

		VegasCart.remove(
			{
				id: $(this).data('id'),
			},
			function (data) {
				$row.removeClass('in-cart');
			}
		);

		return false;
	});
	// добавление товара из производства через прайс
	$document.on('click', '.page-block.product [data-cart][data-action=add]', function () {
		var $product = $(this).closest('.product');

		VegasCart.add(
			{
				id: $(this).data('id'),
				cnt: 1,
			},
			function (data) {
				$product.addClass('in-cart');
			}
		);

		return false;
	});
	// удаление товара из корзины
	$document.on('click', '.table-cart-products [data-cart][data-action=remove]', function () {
		var $row = $(this).closest('.row');
		var pivot_id = $row.data('pivot_id');

		if (confirm('Вы действительно хотите убрать товар из корзины?')) {
			VegasCart.remove(
				{
					pivot_id: pivot_id,
				},
				function (data) {
					$row.remove();

					if (!data.products_count) {
						location.reload();
					}
				}
			);
		}

		return false;
	});
	// изменение кол-ва товара в корзине
	$document.on('change-counter', '.table-cart-products input[name=cnt]', function () {
		var $row = $(this).closest('.row');
		var pivot_id = $row.data('pivot_id');
		var cnt = $(this).val();

		VegasCart.changeCnt({
			pivot_id: pivot_id,
			cnt: cnt
		}, function (data) {
			if (data.product_sum) {
				$row.find('.price-total').html(data.product_sum_formatted);
			}
		});

		return false;
	});
	// изменение кол-ва товара из таблицы прайса
	$document.on('change-counter', '.table-price-products .row.in-cart input[name=cnt]', function () {
		var $row = $(this).closest('.row');
		var pivot_id = $row.data('pivot_id');
		var cnt = $(this).val();

		VegasCart.changeCnt({
			pivot_id: pivot_id,
			cnt: cnt
		});

		return false;
	});

	$(document).on('change', '#form-order [name=delivery_id]', function () {
		var val = $(this).val();
		var $formOrder = $(this).closest("#form-order");

		$formOrder.find('.delivery-info').removeClass('active');
		$formOrder.find('.delivery-info[data-delivery="' + val + '"]').addClass('active');

		$formOrder.find('.mark-required').removeAttr('required');
		$formOrder.find('.delivery-info.active .mark-required').attr('required', 'required');

		return false;
	});

	$modalOrder.on('show.bs.modal', function () {
		$.get('/cart/modal_order', {}, function (data) {
			$modalOrder.find('.modal-body').html(data.view);
			Vegas.enablePlugins_Inputmask($modalOrder.find('[data-mask]'));
		});

		$modalOrder.find('[name=delivery_id]').first().trigger('change');
	});

	$(document).on('submit', "#form-order", function () {
		$(this).find('[type=submit]').attr('disabled', 'disabled').text('Оформление заказа...');
	});

	var $modalProductComment = $("#modal-product-comment");
	$(document).on('click', '.table-cart-products .btn-comment-to-product', function () {
		var $row = $(this).closest('.row[data-pivot_id]');
		var pivot_id = $row.data('pivot_id');
		var comment = $row.find('.cmnt').val();

		$modalProductComment.find('[name=comment]').val(comment);
		$modalProductComment.data('pivot_id', pivot_id);
		$modalProductComment.modal('show');

		return false;
	});
	$modalProductComment.on('hide.bs.modal', function () {
		var pivot_id = $(this).data('pivot_id');
		var $row = $('.table-cart-products .row[data-pivot_id="'+pivot_id+'"]');

		$row.find('.cmnt').val($(this).find('[name=comment]').val());

		$modalOrder.find('[name=delivery_id]').first().trigger('change');
	});
});